<template>
<nav class="page-control" :class="(!pageControl.left && !pageControl.right && !pageControl.up && !pageControl.down && $route.path == '/')? 'hidden': ''">
  <b-button-group>
    <b-button v-if="pageControl.left" :variant="pageControl.lightTheme? 'light': 'outline-dark'" @click="click('left')"><font-awesome-icon icon="angle-left" /></b-button>
    <b-button v-else :variant="pageControl.lightTheme? 'outline-light': 'dark'" disabled><font-awesome-icon icon="angle-left" /></b-button>

    <b-button v-if="pageControl.right" :variant="pageControl.lightTheme? 'light': 'outline-dark'" @click="click('right')"><font-awesome-icon icon="angle-right" /></b-button>
    <b-button v-else :variant="pageControl.lightTheme? 'outline-light': 'dark'" disabled><font-awesome-icon icon="angle-right" /></b-button>

    <b-button v-if="pageControl.up" :variant="pageControl.lightTheme? 'light': 'outline-dark'" @click="click('up')"><font-awesome-icon icon="angle-up" /></b-button>
    <b-button v-else :variant="pageControl.lightTheme? 'outline-light': 'dark'" disabled><font-awesome-icon icon="angle-up" /></b-button>

    <b-button v-if="pageControl.down" :variant="pageControl.lightTheme? 'light': 'outline-dark'" @click="click('down')"><font-awesome-icon icon="angle-down" /></b-button>
    <b-button v-else :variant="pageControl.lightTheme? 'outline-light': 'dark'" disabled><font-awesome-icon icon="angle-down" /></b-button>
  </b-button-group>
</nav>
</template>
<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'PageControl',

  computed: {
    ...mapState({
      pageControl: state => state.pageControl
    })
  },
  methods: {
    ...mapActions({
      updatePageChange: 'doUpdatePageChanger'
    }),
    click(direction) {

      if (this.$route.name == 'Home') {
        if (location.hash == '#artwork') {
          if (direction == 'down') {
            this.$router.push({ name: 'artwork2' })
          } else if (direction == 'left') {
            location.hash = "#profile"
            this.updatePageChange()
          } else if (direction == 'right') {
            location.hash = "#order"
            this.updatePageChange()
          }
        } else if (location.hash == '#profile') {
          if (direction == 'left') {
            location.hash = "#top"
            this.updatePageChange()
          } else if (direction == 'right') {
            location.hash = "#artwork"
            this.updatePageChange()
          } else if (direction == 'down') {
            this.$router.push({ name: 'exhibition', params: {pageNo: '1' }})
          }
        } else if (location.hash == '#order') {
          if (direction == 'left') {
            location.hash = "#artwork"
            this.updatePageChange()
          } else if (direction == 'right') {
            location.hash = "#workshop"
            this.updatePageChange()
          }
        } else if (location.hash == '#workshop') {
          if (direction == 'left') {
            location.hash = "#order"
            this.updatePageChange()
          } else if (direction == 'right') {
            location.hash = "#contact"
            this.updatePageChange()
          }
        } else if (location.hash == '#contact') {
          if (direction == 'left') {
            location.hash = "#workshop"
            this.updatePageChange()
          } 
        } 
      }
      
      else if (this.$route.name == 'artwork2') {
        if (direction == 'up') {
          this.$router.push({ name: 'Home', hash: '#artwork' })
        } else if (direction == 'down') {
          this.$router.push({ name: 'artworkMaking' })
        }
      }
      else if (this.$route.name == 'artworkMaking') {
        if (direction == 'up') {
          this.$router.push({ name: 'artwork2' })
        } else if (direction == 'down') {
          this.$router.push({ name: 'pastWorks' })
        }
      }
      else if (this.$route.name == 'pastWorks') {
        if (direction == 'up') {
          this.$router.push({ name: 'artworkMaking' })
        } 
      }
      else if (this.$route.name == 'exhibition') {
        let path = this.$route.path.split('/')
        let pageNo = parseInt(path[path.length - 1])
        // console.log(pageNo)
        if (direction == 'up') {
          if (pageNo == 1) {
            this.$router.push({ name: 'Home', hash: '#profile' })
          } else {
            this.$router.push({ name: 'exhibition', params:{pageNo: '' + (pageNo-1)} })
          }
        } else if (direction == 'down') {
          this.$router.push({ path: '/exhibition/'+(pageNo+1)} )
        } 
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.page-control {
  position: absolute;
  bottom: 13px;
  left: 13px;
  z-index: 10;
  @media screen and (min-width: 768px) {
    bottom: 20px;
    right: 20px;
    left: inherit;
  }
  opacity: 1;
  transition: opacity 0.6s;
  &.hidden {
    opacity: 0;
    pointer-events: none;
  }
  .btn.disabled {
    opacity: 1 !important;
    pointer-events: none;
  }
  .btn.btn-dark.disabled:hover {
    color: #fff;
    background-color: #343a40;
  }
  .btn:hover, .btn:not(:disabled):active {
    color: #343a40;
    background-color: #fff;
  }
}
</style>